(function () {
    document.querySelectorAll('[data-mss-gallery]').forEach(function (section) {
        var manifestUrl = section.dataset.galleryManifest;
        var mosaic = section.querySelector('.mss-gallery-mosaic');
        var hidden = section.querySelector('.mss-gallery-hidden-items');
        var caption = section.querySelector('.mss-gallery-caption');
        if (!manifestUrl || !mosaic || !hidden) return;

        fetch(manifestUrl, {credentials: 'same-origin'})
            .then(function (response) {
                if (!response.ok) throw new Error('Gallery manifest unavailable');
                return response.json();
            })
            .then(function (manifest) {
                var photos = Array.isArray(manifest.images) ? manifest.images : [];
                if (!photos.length) {
                    if (caption) caption.textContent = 'A képtár feltöltés alatt áll.';
                    return;
                }
                var fragment = document.createDocumentFragment();
                photos.forEach(function (photo, index) {
                    var link = document.createElement('a');
                    link.className = 'mss-photo-gallery-image';
                    link.href = photo.src;
                    link.dataset.width = photo.width;
                    link.dataset.height = photo.height;
                    link.setAttribute('aria-label', photo.alt || 'Klubfotó');
                    if (index < 10) {
                        link.classList.add('mss-gallery-tile', 'mss-gallery-tile-' + (index + 1));
                        var picture = document.createElement('picture');
                        var avif = document.createElement('source');
                        avif.type = 'image/avif';
                        avif.srcset = photo.avif;
                        picture.appendChild(avif);
                        var img = document.createElement('img');
                        img.src = photo.webp;
                        img.alt = photo.alt || '';
                        img.width = 480;
                        img.height = 360;
                        img.loading = index < 3 ? 'eager' : 'lazy';
                        img.decoding = 'async';
                        picture.appendChild(img);
                        link.appendChild(picture);
                        if (index === 9) {
                            var more = document.createElement('span');
                            more.className = 'mss-gallery-more';
                            more.innerHTML = '<strong>' + photos.length + '</strong><span>Összes fotó</span>';
                            link.appendChild(more);
                        }
                        mosaic.appendChild(link);
                    } else {
                        link.classList.add('mss-gallery-hidden-link');
                        fragment.appendChild(link);
                    }
                });
                hidden.appendChild(fragment);
                var extras = section.querySelector('.mss-gallery-cms-items');
                if (extras) extras.querySelectorAll('a.mss-photo-gallery-image').forEach(function (link) { hidden.appendChild(link); });
                if (caption) caption.textContent = photos.length + ' klubfotó · Kattints a képtár megnyitásához.';
                section.classList.add('is-loaded');
            })
            .catch(function () {
                if (caption) caption.textContent = 'A képtár most nem érhető el. Próbáld újratölteni az oldalt.';
            });
    });
})();
